import clsx from "clsx";
import { useState } from "react";
import Icon from "@wff/components/ui/icon";
import classes from "./AccordionItem.module.scss";

export const ACCORDION_ITEM_ID = "accordion-item";

type Props = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

export const AccordionItem = ({ title, children, className }: Props) => {
  const [isActive, setIsActive] = useState(false);
  const setIsActiveHandler = () => {
    setIsActive(!isActive);
  };

  return (
    <div className={classes["accordion-item__container"]}>
      <div
        data-testid={ACCORDION_ITEM_ID}
        className={clsx(
          classes["accordion-item"],
          isActive && classes["active"],
          className
        )}
      >
        <div
          className={classes["accordion-item__header"]}
          onClick={setIsActiveHandler}
        >
          <h3>{title}</h3>
          <div className={classes["accordion-item__icon"]}>
            {isActive ? (
              <Icon iconName="arrow-up" />
            ) : (
              <Icon iconName="arrow-down" />
            )}
          </div>
        </div>
        <div className={classes["accordion-item__content"]}>
          <div className={classes["answer-text"]}>{children}</div>
        </div>
      </div>
    </div>
  );
};
